import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarParametroLocalidadeDetalheRequest, Types } from './types';

// ACTIONS
import {
	consultarParametroLocalidadeDetalheSuccess,
	consultarParametroLocalidadeDetalheFailure,
} from './actions';

function* consultarParametroLocalidadeDetalhe(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarParametroLocalidadeDetalheRequest } =
		request;

	const body = {
		idOrgao: payload.idOrgao,
	};

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades/${payload.sigla}/localidades`,
		body,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(consultarParametroLocalidadeDetalheSuccess(response));
	} else {
		yield put(consultarParametroLocalidadeDetalheFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE,
		consultarParametroLocalidadeDetalhe,
	),
]);
